<template>
  <div class="item-detail-component" :style="{ width }" @click="handlerItemDetailClick">
    <div class="item-img-area">
      <van-image
        :ref="'fly-img' + item.itemId"
        width="100%"
        height="100%"
        fit="contain"
        :src="compressImg(item.mainImg)"
      >
        <!-- <slot><span v-if="isDrugItem && item.isRx === RxTypeNum.CHUFANGYA0" class="rp-tag prescription"></span></slot> -->
        <slot><span v-if="isDrugItem && item.isRx === RxTypeNum.OTC" class="rp-tag otc"></span></slot>

        <template v-slot:error>
          <img width="90%" height="90%" fit="contain" :src="require('@/assets/imgs/home/shop.png')" />
        </template>

        <template v-slot:loading>
          <img width="90%" height="90%" fit="contain" :src="require('@/assets/imgs/home/shop.png')" />
        </template>
      </van-image>
      <span
        class="rx-shade"
        v-if="isDrugItem && item.isRx === RxTypeNum.CHUFANGYA0 && rxShadeConfig['shop-compliance-open']"
        :style="rxShadeStyle"
      >
        {{ rxShadeConfig['shop-compliance-content']['tips'] }}
      </span>
    </div>
    <FlyProduct
      targetId="fly-cart-target"
      :dropImage="item.mainImg + '?x-oss-process=image/resize,m_fill,w_14,h_14'"
      :ref="'fly-product' + item.itemId"
      class="drop-image"
    />
    <div class="item-detail-text-area">
      <div style="min-height: 60px">
        <span class="item-name van-multi-ellipsis--l2">{{ `${item.name}${item.specifications}` }}</span>

        <img
          v-if="item.hasCoupon"
          width="17px"
          height="12px"
          fit="contain"
          :src="require('@/assets/imgs/coupon/category-coupon.png')"
        />
      </div>

      <span class="item-price-line">
        <span class="item-price">{{ item.realPrice | price }}</span>

        <div class="action" @click.stop="stop" :class="{ 'min-width': item.goodsNumAdded > 0 }">
          <van-stepper
            :class="{ 'hide-input': !item.goodsNumAdded || item.goodsNumAdded <= 0 }"
            :ref="'stepper' + item.itemId"
            :value="item.goodsNumAdded || ''"
            theme="round"
            integer
            :disable-input="true"
            allow-empty
            @plus="plus(item)"
            @minus="minus(item)"
            @blur="handleBlur"
            @overlimit="overlimit(item)"
            @change="handChange"
            async-change
            :show-minus="item.goodsNumAdded > 0"
            :show-plus="item.stock !== 0"
            :min="0"
            :max="item.stock < 999 ? item.stock : 999"
            button-size="22"
          />
        </div>
      </span>
      <!-- <span class="item-shop">{{ item.shopName }}</span> -->
    </div>
  </div>
</template>
<script>
import FlyProduct from './flyProduct.vue';
import { RxTypeNum } from '@/constant';
import { mapState } from 'vuex';

export default {
  components: { FlyProduct },
  props: {
    item: {
      type: Object,
      default: () => ({
        goodsNumAdded: null,
        attribute: null,
        stock: null
      })
    },
    width: {
      type: Number | String,
      default: 172
    },
    isAdvertising: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      compressImg: window.util.compressImg,
      RxTypeNum
    };
  },
  computed: {
    ...mapState(['rxShadeConfig']),
    rxShadeStyle() {
      const content = this.rxShadeConfig['shop-compliance-content'];
      return {
        color: `#${content.textColor}`,
        background: `#${content.bgColor}`,
        opacity: content.alpha,
        fontSize: `${content.textSize}px`
      };
    },
    isDrugItem() {
      return this.item.isDrug === 1;
    }
  },
  methods: {
    handlerItemDetailClick() {
      const { itemId, isDrug } = this.item;

      this.$router.push({ path: `/specification?itemId=${itemId}&isDrug=${isDrug}` });
    },
    stop() {
      // do noThing
    },

    plus() {
      const { itemId } = this.item;

      const goodsNumAdded = Number(this.$refs['stepper' + itemId].currentValue) + 1;

      this.addTrolley(goodsNumAdded, 'plus');
    },
    minus() {
      const goodsNumAdded = Number(this.$refs['stepper' + this.item.itemId].currentValue) - 1;
      if (goodsNumAdded < 1) {
        this.deleteTrolley();
        return;
      }
      this.addTrolley(goodsNumAdded);
    },
    handleBlur() {
      const goodsNumAdded = Number(this.$refs['stepper' + this.item.itemId].currentValue);

      if (goodsNumAdded === 0) {
        this.$refs['stepper' + this.item.itemId].currentValue = 1;
        return this.addTrolley(1, true);
      }
      this.addTrolley(goodsNumAdded);
    },
    overlimit() {
      if (this.item.stock < 999) {
        this.$toast(`库存有限，不能购物更多了哦`);
        // this.$toast(`您最多可购买${this.item.stock}件`);
      } else {
        this.$toast('最多只能购买999件');
      }
    },
    handChange(v) {
      if (v === 999 || v === this.item.stock) return;
      this.isTip = !!(Number(v) > this.item.stock);
    },

    deleteTrolley() {
      const { itemId, isDrug } = this.item;
      this.$dialog
        .confirm({
          title: '确认从购物车中删除？',
          confirmButtonText: '再想想',
          cancelButtonText: '删除'
        })
        .then(() => {
          this.$refs['stepper' + itemId].currentValue = this.item.goodsNumAdded;
        })
        .catch(() => {
          this.$fetch.deleteTrolley({ itemId, isDrug }).then(() => {
            this.$emit('onCartChange');
            this.item.goodsNumAdded = 0;
          });
        });
    },
    addTrolley(goodsNumAdded, status) {
      if (goodsNumAdded === this.item.goodsNumAdded) return;
      const { itemId, isDrug } = this.item;
      this.$fetch
        .addTrolley({ itemId, amount: goodsNumAdded, isDrug })
        .then(({ amount, stockNum, canAdd, message = '' }) => {
          this.$nextTick(() => {
            this.$set(this.item, 'goodsNumAdded', amount);
          });

          if (!canAdd) {
            this.item.stock = stockNum;
            this.$toast(message);
            this.item.goodsNumAdded = amount;
            this.$refs['stepper' + this.item.itemId].currentValue = amount;
            return;
          }
          if (status === 'plus') {
            window.localStorage.setItem('recentAddType', isDrug);

            this.$refs['fly-product' + itemId].addToCart(this.$refs['fly-img' + itemId]);
          }

          if (goodsNumAdded === 1 && status === 'plus') {
            this.$emit('onCartChange');
          }

          if (this.isTip) {
            this.overlimit();
          }
        });
    }
  }
};
</script>
<style lang="less" scoped>
.item-detail-component {
  width: 172px;
  // height: 282px;
  // background: #ffffff;
  // border-radius: 8px;
  position: relative;
  // overflow: hidden;
  .item-img-area {
    position: relative;
    width: 100%;
    padding: 0;
    padding-top: 100%;
    overflow: hidden;
    background: #ffffff;
    border-radius: 8px 8px 0 0;
    .rp-tag {
      width: 32px;
      height: 14px;
      display: inline-block;
      position: absolute;
      top: 12px;
      left: 12px;
      &.prescription {
        background: url('../../../assets/imgs/tag_chufang.png') no-repeat top left/100% 100%;
      }
      &.otc {
        background: url('../../../assets/imgs/tag_otc.png') no-repeat top left/100% 100%;
      }
    }

    /deep/ .van-image {
      position: absolute;
      top: 0;
      left: 0;
      .van-image__loading-icon,
      .van-image__error-icon {
        position: absolute;
        top: 0;
      }
    }
    .rx-shade {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  .drop-image {
    position: absolute;
    z-index: 1000;
    top: 50px;
    left: 50px;
  }
  .item-detail-text-area {
    background: #ffffff;
    border-radius: 0 0 8px 8px;
    padding: 8px 12px;
    .item-name {
      width: 100%;
      font-size: 14px;
      font-weight: 400;
      color: #333333;
      line-height: 1.5;
      margin-bottom: 4px;
      font-weight: 500;
    }
    .item-price-line {
      display: flex;
      align-items: center;
      .item-price {
        font-size: 16px;
        font-weight: 500;
        color: #ff4e47;
        line-height: 1.5;
        overflow-x: hidden;
        &::before {
          content: '￥';
          font-size: 12px;
        }
      }
      .action {
        flex: 1;
        text-align: right;
        &.min-width {
          min-width: 82px;
        }
        .hide-input {
          ::v-deep.van-stepper__input {
            display: none;
          }
        }

        ::v-deep.van-stepper__minus {
          color: #1e8dff;

          background-color: #fff;
          border: 1px solid #118dff;
        }
        ::v-deep.van-stepper__plus {
          color: #fff;
          background-color: #1e8dff;
        }
        ::v-deep.van-stepper__minus,
        ::v-deep.van-stepper__plus {
          &::before,
          &::after {
            border-radius: 1px;
            overflow: hidden;
          }
          &::before {
            height: 2px;
          }
          &::after {
            width: 2px;
          }
        }
        ::v-deep.van-stepper__input {
          width: 30px;
        }
        ::v-deep button {
          height: 24px !important;
          width: 24px !important;
        }
      }
    }
  }
}
</style>
